import { RolI } from "interfaces/Rol";
import { UsuarioI } from "interfaces/Usuario";

export interface infoFetchGetUsuariosI {
  createdAt: string;
  email: string;
  id: number | string;
  apellido: string;
  nombre: string;
  rol: RolI;
  imagen_perfil_url: String;
}

class Usuario implements UsuarioI {
  createdAt: Date;
  email: string;
  id: number | string;
  apellido: string;
  nombre: string;
  rol: RolI;
  pictureUrl: String;

  constructor(infoFetch: infoFetchGetUsuariosI) {
    this.createdAt = new Date(infoFetch.createdAt);
    this.email = infoFetch.email;
    this.id = infoFetch.id;
    this.apellido = infoFetch.apellido;
    this.nombre = infoFetch.nombre;
    this.rol = infoFetch.rol;
    this.pictureUrl = infoFetch.imagen_perfil_url;
  }
}

export const makeUsuario = (infoFetch: infoFetchGetUsuariosI) => {
  console.log("USUARIOS", infoFetch);
  return new Usuario(infoFetch);
};
